import axios from 'axios';
import { saveSingleEndPointLogAPI } from './endpoints/singleEndPointLog';
import * as EnvConstants from '../Constants/EnvConstants';

const shouldSkipLogging = (baseURL) => {
  if (!baseURL) return false;
  if (baseURL.startsWith('https://chat.googleapis')) return true;
  if (
    EnvConstants.AppLogHistoryEndpointApi &&
    baseURL.startsWith(EnvConstants.AppLogHistoryEndpointApi)
  ) {
    return true;
  }
  return false;
};

export const createAxiosInstance = ({
  baseURL,
  token,
  timeout = 6000,
}) => {
  const instance = axios.create({
    baseURL,
    timeout,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    },
  });
  // Success Response Interceptor
  instance.interceptors.response.use(
    async (response) => {
      try {
        const rawRequestData = response.config?.data;
        const requestData =
          typeof rawRequestData === 'string'
            ? JSON.parse(rawRequestData || '{}')
            : rawRequestData || {};
        if (!shouldSkipLogging(response.config?.baseURL)) {
          await saveSingleEndPointLogAPI({
            ProjectCode: EnvConstants.AppAdtopiaUPID,
            Environment: EnvConstants.AppEnv,
            request: requestData,
            url: response.config?.url,
            baseURL: response.config?.baseURL,
            response: response.data,
            statusCode: response.status,
          });
        }
      } catch (logError) {
        console.error(
          'Failed to save API log:',
          logError?.message
        );
      }
      return response;
    },
    // Error Response Interceptor
    async (error) => {
      try {
        const rawRequestData = error.config?.data;
        const requestData =
          typeof rawRequestData === 'string'
            ? JSON.parse(rawRequestData || '{}')
            : rawRequestData || {};
        if (!shouldSkipLogging(error.config?.baseURL)) {
          await saveSingleEndPointLogAPI({
            ProjectCode: EnvConstants.AppAdtopiaUPID,
            Environment: EnvConstants.AppEnv,
            request: requestData,
            url: error.config?.url,
            baseURL: error.config?.baseURL,
            response: {
              errorMessage: error.message,
              statusCode: error.response?.status,
              data: error.response?.data,
              errorCode: error.code,
            },
          });
        }
      } catch (logError) {
        console.error(
          'Failed to save API error log:',
          logError?.message
        );
      }
      return Promise.reject(error);
    }
  );

  return instance;
};